import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum TaskRelationTypeId {
  UNDEFINED = 1,
  ROOM = 2,
  RESERVATION = 3,
}

export class TaskRelationType extends Codebook<TaskRelationTypeId> {
  static readonly UNDEFINED = new TaskRelationType(TaskRelationTypeId.UNDEFINED, () =>
    $t('taskRelationType.undefined'),
  )
  static readonly ROOM = new TaskRelationType(TaskRelationTypeId.ROOM, () =>
    $t('taskRelationType.room'),
  )
  static readonly RESERVATION = new TaskRelationType(TaskRelationTypeId.RESERVATION, () =>
    $t('taskRelationType.reservation'),
  )

  private constructor(
    id: TaskRelationTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
